export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://vinayak-enterprise.in";

export const businessInfo = {
  name: "Vinayak Enterprise",
  legalName: "Vinayak Enterprise",
  description:
    "Vinayak Enterprise provides industrial pipeline, fabrication, infrastructure, maintenance, and engineering services from Vadodara, Gujarat.",
  category: "Industrial Pipeline & Infrastructure Services",
  phone: "+91 98242 86872",
  whatsapp: "+91 98242 86872",
  email: "vinayakenterprise137@gmail.com",
  address: {
    streetAddress: "310, 3rd Floor, Samanvay Sequence, Near Ambe School, Manjalpur",
    addressLocality: "Vadodara",
    addressRegion: "Gujarat",
    postalCode: "390009",
    addressCountry: "IN",
  },
  geo: {
    latitude: 22.2714,
    longitude: 73.1812,
  },
  openingHours: ["Mo-Sa 09:00-18:00"],
  socialProfiles: [
    "https://www.instagram.com/vinayak_enterpriseofficial",
    "https://www.facebook.com/share/1GSXrMQaHs/",
    "https://www.linkedin.com/in/vinayak-enterprise-b53b2a409/",
  ],
};

export const serviceItems = [
  "Process pipeline installation and maintenance",
  "Utility pipeline systems",
  "Cooling water and chilled water pipeline systems",
  "Steam pipeline installation",
  "Fire hydrant and fire sprinkler pipeline systems",
  "Compressed air pipeline distribution",
  "Industrial structure work and fabrication",
  "Industrial valve supply and installation",
  "Thermal, cold, acoustic, and fire-resistant insulation work",
];

export const pageSeo = {
  home: {
    path: "/",
    sectionId: "home",
    title:
      "Industrial Pipeline Services Vadodara | Vinayak Enterprise Gujarat",
    description:
      "Vinayak Enterprise is an industrial pipeline contractor in Vadodara delivering pipeline installation, fabrication, infrastructure maintenance, and engineering services across Gujarat.",
    keywords:
      "Industrial Pipeline Services Vadodara, Infrastructure Services Gujarat, Pipeline Contractor Vadodara, Industrial Fabrication Services, Engineering Services Vadodara",
  },
  about: {
    path: "/about",
    sectionId: "about",
    title: "About Vinayak Enterprise | Industrial Maintenance Company Gujarat",
    description:
      "Learn about Vinayak Enterprise, a Vadodara-based industrial maintenance and infrastructure services company focused on safe execution, dependable teams, and long-term plant support.",
    keywords:
      "Industrial Maintenance Company Gujarat, Vinayak Enterprise Vadodara, industrial infrastructure company, pipeline support Gujarat",
  },
  services: {
    path: "/services",
    sectionId: "services",
    title: "Pipeline Installation Services Vadodara | Industrial Fabrication",
    description:
      "Explore Vinayak Enterprise services for process pipelines, utility pipelines, steam lines, compressed air, fire systems, industrial fabrication, valves, insulation, and structural work.",
    keywords:
      "Pipeline Installation Services, Pipeline Contractor Vadodara, Industrial Fabrication Services, process pipeline, utility pipeline, steam pipeline Gujarat",
  },
  projects: {
    path: "/projects",
    sectionId: "projects",
    title: "Industrial Infrastructure Projects Gujarat | Vinayak Enterprise",
    description:
      "View industrial pipeline, infrastructure, fabrication, and facility execution projects completed by Vinayak Enterprise across Vadodara and Gujarat.",
    keywords:
      "Infrastructure Services Gujarat, industrial projects Gujarat, pipeline projects Vadodara, industrial contractor portfolio",
  },
  companies: {
    path: "/companies",
    sectionId: "companies",
    title: "Industrial Companies Served in Gujarat | Vinayak Enterprise",
    description:
      "See the companies and industrial clients that trust Vinayak Enterprise for pipeline, maintenance, fabrication, and infrastructure support in Gujarat.",
    keywords:
      "industrial companies Gujarat, industrial clients Vadodara, fabrication contractor Gujarat, maintenance partner Vadodara",
  },
  contact: {
    path: "/contact",
    sectionId: "contact",
    title: "Contact Pipeline Contractor Vadodara | Vinayak Enterprise",
    description:
      "Contact Vinayak Enterprise in Manjalpur, Vadodara for industrial pipeline services, fabrication, maintenance, insulation, valve supply, and engineering service enquiries.",
    keywords:
      "Contact Pipeline Contractor Vadodara, Engineering Services Vadodara, industrial maintenance enquiry Gujarat, Vinayak Enterprise contact",
  },
  blogs: {
    path: "/#blogs",
    sectionId: "blogs",
    title: "Industrial Pipeline & Fabrication Blog | Vinayak Enterprise",
    description:
      "Read practical industrial pipeline, fabrication, safety, maintenance, and engineering execution insights from Vinayak Enterprise in Vadodara.",
    keywords:
      "industrial pipeline blog, fabrication services blog, maintenance planning Gujarat, engineering services Vadodara",
  },
  "why-us": {
    path: "/#why-us",
    sectionId: "why-us",
    title: "Trusted Industrial Contractor Gujarat | Why Vinayak Enterprise",
    description:
      "Discover why industrial facilities choose Vinayak Enterprise for reliable pipeline work, fabrication, safety-first maintenance, and timely infrastructure execution.",
    keywords:
      "trusted industrial contractor Gujarat, pipeline contractor Vadodara, industrial maintenance company Gujarat",
  },
};

export const sectionLinks = [
  { id: "home", label: "Home", href: "/" },
  { id: "about", label: "About", href: "/about" },
  { id: "services", label: "Services", href: "/services" },
  { id: "why-us", label: "Why Us", href: "/#why-us" },
  { id: "projects", label: "Projects", href: "/projects" },
  { id: "companies", label: "Companies", href: "/companies" },
  { id: "blogs", label: "Blogs", href: "/#blogs" },
  { id: "contact", label: "Contact", href: "/contact" },
];

export const faqItems = [
  {
    question: "Which industrial pipeline services does Vinayak Enterprise provide in Vadodara?",
    answer:
      "Vinayak Enterprise provides process pipeline, utility pipeline, cooling water, chilled water, steam, compressed air, fire hydrant, and fire sprinkler pipeline services for industrial facilities.",
  },
  {
    question: "Does Vinayak Enterprise handle industrial fabrication services?",
    answer:
      "Yes. The team supports industrial structural work, pipe racks, platforms, support structures, valve installation, insulation work, and fabrication-linked site execution.",
  },
  {
    question: "Where is Vinayak Enterprise located?",
    answer:
      "Vinayak Enterprise is located at 310, 3rd Floor, Samanvay Sequence, Near Ambe School, Manjalpur, Vadodara, Gujarat 390009, India.",
  },
  {
    question: "How can I contact Vinayak Enterprise for a pipeline or maintenance enquiry?",
    answer:
      "You can call or WhatsApp +91 98242 86872, email vinayakenterprise137@gmail.com, or submit the contact form on the website.",
  },
];

export const getSiteUrl = () => SITE_URL.replace(/\/$/, "");

export const getAbsoluteUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getSiteUrl()}${normalizedPath}`;
};

const addressSchema = {
  "@type": "PostalAddress",
  streetAddress: businessInfo.address.streetAddress,
  addressLocality: businessInfo.address.addressLocality,
  addressRegion: businessInfo.address.addressRegion,
  postalCode: businessInfo.address.postalCode,
  addressCountry: businessInfo.address.addressCountry,
};

export const createBreadcrumbSchema = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: getAbsoluteUrl(item.path),
  })),
});

export const createOrganizationSchema = () => ({
  "@type": "Organization",
  "@id": `${getAbsoluteUrl("/") }#organization`,
  name: businessInfo.name,
  legalName: businessInfo.legalName,
  url: getAbsoluteUrl("/"),
  logo: getAbsoluteUrl("/images/logo.jpeg"),
  image: getAbsoluteUrl("/images/logo.jpeg"),
  description: businessInfo.description,
  email: businessInfo.email,
  telephone: businessInfo.phone,
  sameAs: businessInfo.socialProfiles,
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: businessInfo.phone,
      contactType: "customer service",
      areaServed: ["Vadodara", "Gujarat", "India"],
      availableLanguage: ["English", "Hindi", "Gujarati"],
    },
    {
      "@type": "ContactPoint",
      telephone: businessInfo.whatsapp,
      contactType: "WhatsApp",
      areaServed: ["Vadodara", "Gujarat", "India"],
      availableLanguage: ["English", "Hindi", "Gujarati"],
    },
  ],
  address: addressSchema,
});

export const createLocalBusinessSchema = () => ({
  "@type": "LocalBusiness",
  "@id": `${getAbsoluteUrl("/") }#local-business`,
  name: businessInfo.name,
  url: getAbsoluteUrl("/"),
  image: getAbsoluteUrl("/images/logo.jpeg"),
  logo: getAbsoluteUrl("/images/logo.jpeg"),
  description: businessInfo.description,
  telephone: businessInfo.phone,
  email: businessInfo.email,
  priceRange: "$$",
  address: addressSchema,
  geo: {
    "@type": "GeoCoordinates",
    latitude: businessInfo.geo.latitude,
    longitude: businessInfo.geo.longitude,
  },
  openingHours: businessInfo.openingHours,
  areaServed: [
    { "@type": "City", name: "Vadodara" },
    { "@type": "State", name: "Gujarat" },
  ],
  sameAs: businessInfo.socialProfiles,
  makesOffer: serviceItems.map((serviceName) => ({
    "@type": "Offer",
    itemOffered: {
      "@type": "Service",
      name: serviceName,
      provider: { "@id": `${getAbsoluteUrl("/") }#local-business` },
      areaServed: "Vadodara, Gujarat, India",
    },
  })),
});

export const createWebsiteSchema = () => ({
  "@type": "WebSite",
  "@id": `${getAbsoluteUrl("/") }#website`,
  name: businessInfo.name,
  url: getAbsoluteUrl("/"),
  description: businessInfo.description,
  publisher: { "@id": `${getAbsoluteUrl("/") }#organization` },
  inLanguage: "en-IN",
});

export const createServicesSchema = () => ({
  "@type": "ItemList",
  "@id": `${getAbsoluteUrl("/services") }#services`,
  name: "Industrial Pipeline and Infrastructure Services",
  itemListElement: serviceItems.map((name, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@type": "Service",
      name,
      serviceType: name,
      provider: { "@id": `${getAbsoluteUrl("/") }#local-business` },
      areaServed: "Vadodara, Gujarat, India",
      url: getAbsoluteUrl("/services"),
    },
  })),
});

export const createFaqSchema = () => ({
  "@type": "FAQPage",
  "@id": `${getAbsoluteUrl("/") }#faq`,
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
});

export const createPageSchema = (pageKey) => {
  const page = pageSeo[pageKey] || pageSeo.home;
  const path = page.path.startsWith("/#") ? "/" : page.path;

  return {
    "@type": pageKey === "services" ? "CollectionPage" : "WebPage",
    "@id": `${getAbsoluteUrl(path)}#webpage`,
    url: getAbsoluteUrl(path),
    name: page.title,
    description: page.description,
    isPartOf: { "@id": `${getAbsoluteUrl("/") }#website` },
    about: { "@id": `${getAbsoluteUrl("/") }#local-business` },
    inLanguage: "en-IN",
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: getAbsoluteUrl("/images/logo.jpeg"),
    },
  };
};

export const createHomeSchema = () => ({
  "@context": "https://schema.org",
  "@graph": [
    createOrganizationSchema(),
    createLocalBusinessSchema(),
    createWebsiteSchema(),
    createPageSchema("home"),
    createServicesSchema(),
    createFaqSchema(),
    createBreadcrumbSchema([{ name: "Home", path: "/" }]),
  ],
});

export const createSectionSchema = (pageKey) => {
  const page = pageSeo[pageKey] || pageSeo.home;

  return {
    "@context": "https://schema.org",
    "@graph": [
      createOrganizationSchema(),
      createLocalBusinessSchema(),
      createWebsiteSchema(),
      createPageSchema(pageKey),
      ...(pageKey === "services" ? [createServicesSchema(), createFaqSchema()] : []),
      ...(pageKey === "contact" ? [createFaqSchema()] : []),
      createBreadcrumbSchema([
        { name: "Home", path: "/" },
        { name: pageKey === "why-us" ? "Why Us" : page.sectionId.replace("-", " "), path: page.path },
      ]),
    ],
  };
};
